import React, { Component } from "react";
import { connect } from "react-redux";
import { Upload, Modal, Divider, Button, message } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import { uploadProductImage } from "../../../actions/productDetails";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class PicturesWall extends Component {
  state = {
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    fileList: [],
    uploading: false,
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };

  beforeUpload = (file) => {
    // Check file size (5MB limit)
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Image must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }

    // Check file type
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }

    return false; // Prevent automatic upload
  };

  updateimage = async () => {
    if (this.state.fileList.length === 0) {
      message.warning("Please select at least one image to upload.");
      return;
    }

    this.setState({ uploading: true });

    try {
      // Upload all images sequentially
      for (const file of this.state.fileList) {
        const formData = new FormData();
        formData.append("photo", file.originFileObj);
        
        if (this.props.porductid) {
          formData.append("ProductDetails", this.props.porductid);
        }
        if (this.props.variationid) {
          formData.append("ProductLocation", this.props.variationid);
        }
        if (this.props.Color) {
          formData.append("Color", this.props.Color);
        }
        if (this.props.cover) {
          formData.append("is_active", this.props.cover);
        }
        
        await this.props.uploadProductImage(formData, this.props.porductid);
      }

      message.success("Images uploaded successfully!");
      
      // Reset state
      this.setState({
        previewVisible: false,
        previewImage: "",
        previewTitle: "",
        fileList: [],
        uploading: false,
      });

      // Refresh parent component
      setTimeout(() => {
        this.props.setnewimage(true);
      }, 1000);
      
    } catch (error) {
      message.error("Failed to upload images. Please try again.");
      this.setState({ uploading: false });
      console.error("Upload error:", error);
    }
  };

  handleChange = (info) => {
    let fileList = [...info.fileList];

    // Limit the number of uploaded files
    fileList = fileList.slice(-5);

    // Filter out files that exceed size limit
    fileList = fileList.filter(file => {
      if (file.size && file.size / 1024 / 1024 > 5) {
        message.error(`${file.name} exceeds 5MB limit and was removed.`);
        return false;
      }
      return true;
    });

    this.setState({ fileList });
  };

  render() {
    const { previewVisible, previewImage, fileList, previewTitle, uploading } = this.state;
    
    const uploadButton = (
      <div>
        {uploading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    return (
      <>
        <Upload
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          beforeUpload={this.beforeUpload}
          maxCount={this.props.limit}
          accept="image/*"
          disabled={uploading}
        >
          {fileList.length >= this.props.limit ? null : uploadButton}
        </Upload>
        
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="preview" style={{ width: "100%" }} src={previewImage} />
        </Modal>
        
        <Button 
          type="primary" 
          size="small" 
          onClick={this.updateimage}
          loading={uploading}
          disabled={fileList.length === 0}
        >
          {uploading ? "Uploading..." : "Upload"}
        </Button>
        
        {fileList.length > 0 && (
          <div style={{ marginTop: 8, fontSize: 12, color: "#666" }}>
            {fileList.length} image(s) selected
          </div>
        )}
      </>
    );
  }
}

export default connect(null, { uploadProductImage })(PicturesWall);